(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["el-lp-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('el-pg-carousel')) {
    customElements.define('el-pg-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pgc-track]');
        this.prev = this.querySelector('[data-pgc-prev]');
        this.next = this.querySelector('[data-pgc-next]');
        this.dots = this.querySelector('[data-pgc-dots]');
        if (!this.track) return;
        this._raf = 0;
        this._pages = -1;
        this._onScroll = () => { cancelAnimationFrame(this._raf); this._raf = requestAnimationFrame(() => this.sync()); };
        this.track.addEventListener('scroll', this._onScroll, { passive: true });
        if (this.prev) this.prev.addEventListener('click', () => this.go(this.current() - 1));
        if (this.next) this.next.addEventListener('click', () => this.go(this.current() + 1));
        this._ro = new ResizeObserver(() => this.sync());
        this._ro.observe(this.track);
        this.sync();
      }
      disconnectedCallback() {
        if (this._ro) this._ro.disconnect();
        if (this.track) this.track.removeEventListener('scroll', this._onScroll);
      }
      metrics() {
        const items = this.track.children;
        const n = items.length;
        if (n < 1) return null;
        const step = n > 1 ? items[1].offsetLeft - items[0].offsetLeft : items[0].offsetWidth;
        const gap = Math.max(0, step - items[0].offsetWidth);
        const pv = Math.max(1, Math.round((this.track.clientWidth + gap) / step));
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const pages = Math.max(1, Math.ceil(n / pv));
        const offsets = [];
        for (let i = 0; i < pages; i++) offsets.push(Math.min(i * pv * step, max));
        return { offsets, pages, max };
      }
      current() {
        const m = this.metrics();
        if (!m) return 0;
        let best = 0;
        let d = Infinity;
        m.offsets.forEach((o, i) => { const dd = Math.abs(o - this.track.scrollLeft); if (dd < d) { d = dd; best = i; } });
        return best;
      }
      go(i) {
        const m = this.metrics();
        if (!m) return;
        const idx = Math.max(0, Math.min(m.pages - 1, i));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: m.offsets[idx], behavior: reduce ? 'auto' : 'smooth' });
      }
      sync() {
        const m = this.metrics();
        if (!m) return;
        const multi = m.pages > 1;
        if (this.dots) {
          if (this._pages !== m.pages) {
            this._pages = m.pages;
            this.dots.textContent = '';
            for (let i = 0; i < m.pages; i++) {
              const b = document.createElement('button');
              b.type = 'button';
              b.className = 'el-pgc__dot';
              b.setAttribute('aria-label', 'Go to page ' + (i + 1));
              b.addEventListener('click', () => this.go(i));
              this.dots.appendChild(b);
            }
          }
          this.dots.hidden = !multi;
        }
        const cur = this.current();
        if (this.dots) Array.prototype.forEach.call(this.dots.children, (b, i) => b.setAttribute('aria-current', i === cur ? 'true' : 'false'));
        if (this.prev) { this.prev.hidden = !multi; this.prev.disabled = cur <= 0; }
        if (this.next) { this.next.hidden = !multi; this.next.disabled = cur >= m.pages - 1; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
